import { Backdrop, Box, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Button, makeStyles } from '@material-ui/core';
import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        borderRadius: 12,
        padding: theme.spacing(2),
        textAlign: 'center',
        minWidth: 400,
    },
    dialogTitle: {
        paddingBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    iconSuccess: {
        fontSize: 80,
        color: '#4CAF50',
    },
    iconError: {
        fontSize: 80,
        color: '#f44336',
    },
    dialogContent: {
        padding: theme.spacing(3, 2),
        fontSize: '1.1rem',
        color: theme.palette.text.secondary,
    },
    dialogActions: {
        justifyContent: 'center',
        paddingBottom: theme.spacing(2),
    },
    buttonSuccess: {
        backgroundColor: '#4CAF50',
        color: 'white',
        padding: theme.spacing(1, 4),
        borderRadius: 25,
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#45a049',
        },
    },
    buttonError: {
        backgroundColor: '#f44336',
        color: 'white',
        padding: theme.spacing(1, 4),
        borderRadius: 25,
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#da190b',
        },
    },
}));

interface ModalFullLSEProps {
    error: {
        has: boolean, message: string
    },
    loading: {
        is: boolean, message: string
    },
    success: {
        has: boolean, message: string
    },
    titles?: {
        error: string, loading: string, success: string
    },
    onDone(success: boolean): void,
}

export default function ModalFullLSE({ error, loading, success, onDone, titles = {
    error: 'Houve um erro!', loading: 'Carregando...', success: 'Sucesso'
}, ...props }: ModalFullLSEProps) {
    const classes = useStyles();

    return (<>
        <Backdrop style={{ zIndex: 1300 + 1 }} open={loading.is}>
            <CircularProgress color="inherit" />
            <Box ml={2} color="white">{loading.message}</Box>
        </Backdrop>

        <Dialog
            open={success.has}
            onClose={() => onDone(true)}
            classes={{ paper: classes.dialogPaper }}
            style={{ zIndex: 1300 + 2 }}
        >
            <DialogTitle className={classes.dialogTitle}>
                <CheckCircleIcon className={classes.iconSuccess} />
                <span>{titles.success}</span>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                {success.message}
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button onClick={() => onDone(true)} className={classes.buttonSuccess}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={error.has}
            onClose={() => onDone(false)}
            classes={{ paper: classes.dialogPaper }}
            style={{ zIndex: 1300 + 2 }}
        >
            <DialogTitle className={classes.dialogTitle}>
                <ErrorIcon className={classes.iconError} />
                <span>{titles.error}</span>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                {error.message}
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button onClick={() => onDone(false)} className={classes.buttonError}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    </>)
}
